import { BiInfoCircle } from 'react-icons/bi';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Text,
  theme,
  VStack,
} from 'ui_2';

export type FAQEntry = {
  title: string;
  content: string[];
};

export const FAQModal = ({ entry }: { entry: FAQEntry }) => {
  return (
    <Dialog>
      <DialogTrigger asChild className='hover:cursor-pointer'>
        <div>
          <BiInfoCircle color={theme.colors.gray[500]} size={20} />
        </div>
      </DialogTrigger>
      <DialogContent className='w-[calc(100%-32px)] rounded-[10px]'>
        <DialogTitle>
          <Text font='medium-sm'>{entry.title}</Text>
        </DialogTitle>
        <VStack className='gap-2'>
          {entry.content.map((paragraph, ix) => (
            <Text font='sm' key={ix}>
              {paragraph}
            </Text>
          ))}
        </VStack>
      </DialogContent>
    </Dialog>
  );
};
